export const permissionData = {
  analysis: {
    feature: 'Analysis',
    screen: {
      detail_vc: 'Detail VC',
      summary_vc: 'Summary VC',
    },
    action: {
      save: 'Save',
      view: 'View',
    },
    rowItems: {
      detail_vc: {
        availableColumns: {
          discipline_area: 'Discipline Area',
          product_category: 'Product Category',
          product_sub_category: 'Product Sub Category',
          hs_code: 'HS Code',
          hsn: 'HSN',
          cbm: 'CBM',
          unit_weight: 'Unit Weight',
          name: 'Name',
          specification: 'Specification',
          uom: 'UOM',
          percentage: 'Percentage',
          qty: 'Qty',
          savings: 'Savings',
          selected: 'Selected',
          selected_total_price: 'Selected MU Total',
          selected_unit_price: 'Selected MU Unit Price',
          spec_id: 'Spec ID',
          finish_spec_id: 'Finish Spec ID',
          finish_name: 'Finish Name',
          // "total_price": "Total Price",
          total_price_base: 'Total Price Base',
          // "unit_price": "Unit Price",
          unit_price_base: 'Unit Price Base',
          vendor_spec: 'Vendor Spec',
          internal_comments: 'Internal Comments',
          selected_vendor_name: 'Selected Vendor Name',
          markup: 'Markup',
          markup_price: 'MU Price',
          markup_total_price: 'MU Total',
          vendor_markup: 'Vendor Markup',
        },
      },
      summary_vc: {
        availableColumns: {
          markup: 'Mark Up',
          profit_margin: 'Profit Margin',
        },
      },
    },
  },
  boq_management: {
    feature: 'BoQ Management',
    screen: {
      boq_listing: 'BOQ Listing',
      ffne_boq_details: 'FF&E BoQ Details',
      specifications: 'Specifications',
    },
    action: {
      create: 'Create',
      delete: 'Delete',
      edit: 'Edit',
      view: 'View',
      add_masters: 'Add Masters',
      approval: 'Approval',
      client_view: 'Client View',
      create_versions: 'Create Versions',
      downloads: 'Downloads',
      release_edit_lock: 'Release Edit Lock',
      send_boq_to_user: 'Send BoQ to User',
      view_history: 'View History',
      save_markup: 'Save Markup',
      upload_spec: 'Upload Spec',
    },
    rowItems: {
      boq_listing: {
        availableColumns: {
          action: 'Action',
          boq_ref_no: 'BoQ Ref No',
          last_updated_at: 'Last Updated At',
          last_updated_by: 'Last Updated By',
          status: 'Status',
        },
      },
      ffne_boq_details: {
        availableColumns: {
          action: 'Action',
          area_quantity: 'Area Quantity',
          discipline_area: 'Discipline - Area',
          variant: 'Variant',
          finish_category: 'Finish Category',
          finish_category_type: 'Finish Sub Category',
          hs_code: 'HS Code',
          item_name: 'Item Name',
          multiplier: 'Multiplier',
          product_category: 'Product Category',
          Product_sub_category: 'Product Sub-Category',
          spec_id: 'Spec ID',
          stage: 'Stage',
          status: 'Status',
          total_finish_quantity: 'Total Finish Quantity',
          total_item_quantity: 'Total Item Quantity',
          uom: 'UOM',
        },
      },
      specifications: {
        availableColumns: {
          spec_id: 'Spec ID',
          name: 'Name',
          product_sub_category: 'Product Sub-Category',
          specification: 'Specification',
          brand_mfr: 'Brand/Mfr.',
          distributor: 'Distributor',
          uom_id: 'UOM',
          action: 'Action',
        },
      },
    },
  },
  budget_management: {
    feature: 'Budget Management',
    screen: {
      detailed_budget: 'Detailed Budget',
      open_items: 'Open Items',
      summary_budget: 'Summary Budget',
    },
    action: {
      approve: 'Approve',
      comment: 'Comment',
      download: 'Download',
      view: 'View',
      send_to_client: 'Send To Client',
    },
    rowItems: {
      detailed_budget: {
        availableColumns: {
          C_and_D: 'C&D',
          category_sub_category: 'Category/Sub-Category',
          cif: 'CIF',
          discipline_area: 'Discipline-Area',
          duties: 'Duties',
          ex_works: 'Ex Works',
          finish_category: 'Finish Category',
          finish_type: 'Finish Type',
          hs_code: 'HS Code',
          installation_ddp: 'Installation/DDP',
          item_name: 'Item Name',
          markup: 'Markup',
          others: 'Others',
          spec_id: 'Spec ID',
          total: 'Total',
          total_finish_qty: 'Total Finish Qty',
          total_item_qty: 'Total Item Qty',
          unit_price: 'Unit Price',
          uom: 'UOM',
          vendor: 'Vendor',
          warehouse: 'Warehouse',
          vc_comments: 'VC Comments',
          finish_spec_id: 'Finish Spec ID',
          finish_name: 'Finish Name',
          finish_uom: 'Finish UOM',
          finish_category_type: 'Finish Category - Type',
        },
      },
      open_items: {
        availableColumns: {
          action: 'Action',
          discipline_area: 'Discipline-Area',
          variant: 'Variant',
          item_name: 'Item Name',
          product_category: 'Product Category',
          product_sub_category: 'Product Sub-Category',
          stage: 'Stage',
          total_qty: 'Total Qty',
          uom: 'UOM',
          spec_id: 'Spec ID',
          finish_spec_id: 'Finish Spec ID',
          finish_category: 'Finish Category',
          finish_type: 'Finish Sub Category',
          finish_name: 'Finish Name',
          finish_uom: 'Finish UoM',
        },
      },
      summary_budget: {
        availableColumns: {
          action: 'Action',
          approved: 'Approved',
          cif: 'CIF',
          clearance_and_delivery: 'Clearance and Delivery',
          duties: 'Duties',
          installation_ddp: 'Installation/DDP',
          markup: 'Markup',
          other: 'Other',
          package: 'Package',
          profit_margin: 'Profit Margin',
          rfp_name: 'RFP Name',
          sub_total: 'Sub Total',
          taxes: 'Taxes',
          total: 'Grand Total',
          total_vendor_bid: 'Total Vendor Bid',
          vendor_bid: 'Vendor Bid',
          warehouse: 'Warehouse',
        },
      },
    },
  },
  client_administration: {
    feature: 'Client Administration',
    screen: {
      client_listing: 'Client Listing',
    },
    action: {
      create: 'Create',
      create_pqf: 'Create PQF',
      delete: 'Delete',
      edit: 'Edit',
      view: 'View',
    },
    rowItems: {
      client_listing: {
        availableColumns: {
          action: 'Action',
          client_name: 'Client Name',
          email: 'Email',
        },
      },
    },
  },
  designer_administration: {
    feature: 'Designer Administration',
    screen: {
      designer: 'Designer',
    },
    action: {
      create: 'Create',
      delete: 'Delete',
      edit: 'Edit',
      view: 'View',
    },
    rowItems: {
      designer: {
        availableColumns: {
          action: 'Action',
          country: 'Country',
          designer_name: 'Designer Name',
        },
      },
    },
  },
  division_management: {
    feature: 'Division Management',
    screen: {
      division: 'Division',
    },
    action: {
      create: 'Create',
      delete: 'Delete',
      edit: 'Edit',
      view: 'View',
    },
    rowItems: {
      division: {
        availableColumns: {
          action: 'Action',
          currency_code: 'Currency Code',
          name: 'Name',
        },
      },
    },
  },
  enquiry_management: {
    feature: 'Enquiry Management',
    screen: {
      enquiry: 'Enquiry',
      enquiry_form: 'Enquiry Form',
    },
    action: {
      delete: 'Delete',
      update_status: 'Update Status',
      save: 'Save',
      view: 'View',
      send_email: 'Send Email',
    },
    rowItems: {
      enquiry: {
        availableColumns: {
          no_of_keys: '# of Keys',
          action: 'Action',
          company_name: 'Company Name',
          country: 'Country',
          project_name: 'Project Name',
          received_at: 'Received At',
          status: 'Status',
        },
      },
      enquiry_form: {
        availableColumns: {},
      },
    },
  },
  master_data_administration: {
    feature: 'Master Data Administration',
    screen: {
      allowance_agreement: 'Allowance Agreement',
      area: 'Area',
      currency: 'Currency',
      discipline: 'Discipline',
      document_type: 'Document Type',
      finish_category: 'Finish Category',
      finish_category_type: 'Finish Sub Category',
      formula_builder: 'Formula Builder',
      product_category: 'Product Category',
      product_sub_category: 'Product Sub-Category',
      tax_type: 'Tax Type',
      category_markup: 'Category Markup',
    },
    action: {
      edit: 'Edit',
      view: 'View',
      create: 'Create',
      delete: 'Delete',
    },
    rowItems: {
      allowance_agreement: {
        availableColumns: {},
      },
      area: {
        availableColumns: {
          action: 'Action',
          area_name: 'Area Name',
          discipline_name: 'Discipline Name',
          status: 'Status',
        },
      },
      currency: {
        availableColumns: {
          action: 'Action',
          code: 'Code',
          currency_name: 'Currency Name',
          status: 'Status',
          symbol: 'Symbol',
        },
      },
      discipline: {
        availableColumns: {
          action: 'Action',
          discipline_name: 'Discipline Name',
          status: 'Status',
        },
      },
      document_type: {
        availableColumns: {
          action: 'Action',
          areas: 'Areas',
          bulk_uploads: 'Bulk Uploads',
          document_type: 'Document Type',
          source: 'Source',
          status: 'Status',
        },
      },
      finish_category: {
        availableColumns: {
          action: 'Action',
          finish_category_name: 'Finish Category Name',
          status: 'Status',
        },
      },
      finish_category_type: {
        availableColumns: {
          action: 'Action',
          finish_category_name: 'Finish Category Name',
          finish_category_type_name: 'Finish Sub Category Name',
          status: 'Status',
        },
      },
      formula_builder: {
        availableColumns: {},
      },
      product_category: {
        availableColumns: {
          action: 'Action',
          business_unit_type: 'Business Unit Type',
          product_category_name: 'Product Category Name',
          status: 'Status',
        },
      },
      product_sub_category: {
        availableColumns: {
          action: 'Action',
          business_unit_type: 'Business Unit Type',
          product_category_name: 'Product Category Name',
          product_sub_category_name: 'Product Sub-Category Name',
          status: 'Status',
        },
      },
      tax_type: {
        availableColumns: {
          action: 'Action',
          rate: 'Rate(%)',
          status: 'Status',
          tax_type: 'Tax Type',
        },
      },
      category_markup: {
        availableColumns: {
          product_sub_category: 'Product Sub-Category',
          markup: 'Markup %',
          cif: 'CIF %',
          installation: 'Installation %',
          duty: 'Duty %',
          clearance_and_delivery: 'Clearance & Delivery %',
          warehouse: 'Warehouse %',
          other: 'Other %',
          action: 'Action',
        },
      },
    },
  },
  operator_administration: {
    feature: 'Operator Administration',
    screen: {
      operator: 'Operator',
    },
    action: {
      create: 'Create',
      delete: 'Delete',
      edit: 'Edit',
      view: 'View',
    },
    rowItems: {
      operator: {
        availableColumns: {
          action: 'Action',
          country: 'Country',
          operator_name: 'Operator Name',
        },
      },
    },
  },
  project_information: {
    feature: 'Project Information',
    screen: {
      banquets: 'Banquets',
      bill_to_ship_to_adress: 'Bill To/Ship To Address',
      document_register: 'Document Register',
      drawing_and_layouts: 'Drawing & Layouts',
      fnb_restaurents: 'F&B Restaurants',
      ffne_file_uploads: 'FF&E File Uploads',
      input_matrix: 'Input Matrix',
      osne_file_uploads: 'OS&E File Uploads',
      others: 'Others',
      project_logistics: 'Project Logistics',
      recreational_areas: 'Recreational Areas',
      specification_and_finishes: 'Specification & Finishes',
      stakeholder_information: 'Stakeholder Information',
    },
    action: {
      save: 'Save',
      view: 'View',
      edit: 'Edit',
      upload: 'Upload',
    },
    rowItems: {
      banquets: {
        availableColumns: {},
      },
      bill_to_ship_to_adress: {
        availableColumns: {},
      },
      document_register: {
        availableColumns: {
          area: 'Area',
          detail_drawing: 'Detail Drawing',
          drawing_register: 'Client BOQ/RFI',
          elevation_drawing: 'Elevation Drawing',
          'ff&e_specifications': 'FF&E Specifications',
          finish_specifications: 'Finish Specifications',
          furniture_layout_plan: 'Furniture Layout Plan',
          rendering: 'Rendering',
        },
      },
      drawing_and_layouts: {
        availableColumns: {},
      },
      fnb_restaurents: {
        availableColumns: {},
      },
      ffne_file_uploads: {
        availableColumns: {},
      },
      input_matrix: {
        availableColumns: {
          action: 'Action',
          bath_count: 'Bath Count',
          bed_count: 'Bed Count',
          comments: 'Comments',
          covers_chairs: 'Covers/Chairs',
          full_double: 'Full/Double',
          king: 'King',
          kitchen_count: 'Kitchen Count',
          living_count: 'Living Count',
          outlet_name: 'Outlet Name',
          outlet_type: 'Outlet Type',
          powder_count: 'Powder Count',
          queen: 'Queen',
          room_type_name: 'Room Type Name',
          sofa_bed: 'Sofa Bed',
          super_king: 'Super King',
          twin: 'Twin',
          twin_xl: 'Twin XL',
          units: 'Units',
        },
      },
      osne_file_uploads: {
        availableColumns: {},
      },
      others: {
        availableColumns: {},
      },
      project_logistics: {
        availableColumns: {},
      },
      recreational_areas: {
        availableColumns: {},
      },
      specification_and_finishes: {
        availableColumns: {},
      },
      stakeholder_information: {
        availableColumns: {},
      },
    },
  },
  project_management: {
    feature: 'Project Management',
    screen: {
      category_markup: 'Category Markup',
      details: 'Details',
      file_ploads: 'File Uploads',
      project_list: 'Project List',
      specifications: 'Specifications',
      taxes: 'Taxes',
    },
    action: {
      create: 'Create',
      delete: 'Delete',
      edit: 'Edit',
      view: 'View',
      create_versions: 'Create Versions',
      save_markup: 'Save Markup',
      upload_spec: 'Upload Spec',
      view_history: 'View History',
    },
    rowItems: {
      category_markup: {
        availableColumns: {
          action: 'Action',
          cif: 'CIF %',
          clearance_and_delivery: 'Clearance & Delivery %',
          duty: 'Duty %',
          installation: 'Installation %',
          markup: 'Markup %',
          other: 'Other %',
          product_sub_category: 'Product Sub-Category',
          warehouse: 'Warehouse %',
        },
      },
      details: {
        availableColumns: {},
      },
      file_ploads: {
        availableColumns: {
          action: 'Action',
          attached_document_name: 'Attached Document Name',
          comments: 'Comments',
          date_received: 'Date Received',
          document_type: 'Document Type',
        },
      },
      project_list: {
        availableColumns: {},
      },
      specifications: {
        availableColumns: {
          action: 'Action',
          brand_mfr: 'Brand/Mfr.',
          can_vendor_price: 'Can Vendor Price?',
          distributor: 'Distributor',
          finish_type: 'Finish Type',
          name: 'Name',
          product_category: 'Product Category',
          product_sub_category: 'Product Sub-Category',
          spec_id: 'Spec ID',
          specification: 'Specification',
          uom_id: 'uom_id',
        },
      },
      taxes: {
        availableColumns: {
          action: 'Action',
          rate: 'Rate(%)',
          tax_type: 'Tax Type',
        },
      },
    },
  },
  rfp: {
    feature: 'RFP',
    screen: {
      create_rfps: 'Create RFPs',
      detail_costing: 'Item Costing',
      finish_costing: 'Finish Costing',
      finish_quantity: 'Finish Quantity',
      commercial_terms: 'Commercial T&Cs',
      issue_rfps: 'Issue RFPs',
    },
    action: {
      create: 'Create',
      view: 'View',
      comment: 'Comment',
      download: 'Download',
      save: 'Save',
      upload: 'Upload',
      approve: 'Approve',
      issue: 'Issue',
    },
    rowItems: {
      create_rfps: {
        availableColumns: {
          category: 'Category',
          comments: 'Comments',
          discipline_area: 'Discipline-Area',
          hs_code: 'HS Code',
          item_name: 'Item Name',
          qty: 'Qty',
          spec_id: 'Spec ID',
          sub_category: 'Sub-Category',
          uom: 'UOM',
        },
      },
      detail_costing: {
        availableColumns: {
          action: 'Action',
          discipline_area: 'Discipline-Area',
          finish_category: 'Finish Category',
          finish_qty: 'Finish Qty',
          finish_type: 'Finish Type',
          hs_code: 'HS Code',
          item_name: 'Item Name',
          product_category: 'Product Category',
          product_sub_category: 'Product Sub Category',
          spec_id: 'Spec ID',
          total_price: 'Total Price',
          total_qty: 'Total Qty',
          unit_price: 'Unit Price',
          unit_qty: 'Unit Qty',
          uom: 'UoM',
          vendor_spec: 'Vendor Spec',
          cbmPerItem: 'CBM Per Item',
          totalCbm: 'Total CBM',
          weightPerItem: 'Weight Per Item',
          weightUom: 'Weight UoM',
          totalWeight: 'Total Weight',
        },
      },
      finish_costing: {
        availableColumns: {
          action: 'Action',
          discipline_area: 'Discipline-Area',
          item_spec_id: 'Item Spec ID',
          item_name: 'Item Name',
          finish_spec_id: 'Finish Spec ID',
          finish_sub_category: 'Finish Category - Type',
          finish_name: 'Finish Name',
          finish_uom: 'Finish UoM',
          hs_code: 'HS Code',
          vendor_spec: 'Vendor Spec',
          unit_price: 'Unit Price',
          total_qty: 'Total Qty',
          total_price: 'Total Price',
          cbm_per_item: 'CBM Per Item',
          total_cbm: 'Total CBM',
          weight_per_item: 'Weight Per Item',
          weight_uom: 'Weight UoM',
          total_weight: 'Total Weight',
        },
      },
      finish_quantity: {
        availableColumns: {
          action: 'Action',
          discipline_area: 'Discipline-Area',
          item_spec_id: 'Item Spec ID',
          item_name: 'Item Name',
          finish_spec_id: 'Finish Spec ID',
          finish_category_name: 'Finish Category - Type',
          finish_name: 'Finish Name',
          finish_uom: 'Finish UoM',
          hs_code: 'HS Code',
          vendor_quoted_quantity: 'Unit Quantity',
          multiplier: 'Multiplier',
          total_quantity: 'Total Quantity',
          finish_comments: 'Finish Comments',
          uom: 'UoM',
          vendor_spec: 'Vendor Spec',
        },
      },
      commercial_terms: {
        availableColumns: {},
      },
      issue_rfps: {
        availableColumns: {
          category: 'Category',
          comments: 'Comments',
          discipline_area: 'Discipline-Area',
          hs_code: 'HS Code',
          item_name: 'Item Name',
          qty: 'Qty',
          spec_id: 'Spec ID',
          sub_category: 'Sub-Category',
          uom: 'UoM',
        },
      },
    },
  },
  tender_packages: {
    feature: 'Tender Packages',
    screen: {
      boq_packages: 'Tendering Packages',
      spec: 'FF&E Spec',
    },
    action: {
      view: 'View',
      create: 'Create',
      edit: 'Edit',
      save: 'Save',
      delete: 'Delete',
      move_to_package: 'Move to Package',
      comment: 'Comment',
      download: 'Download',
      // Direct Award — award a tender package to one approved vendor without the
      // RFQ / Vendor Costing / CBA chain, and undo that award. Gating is UI-only
      // (the endpoints authenticate but do not authorise), so these two keys are
      // what hides the actions; they must match the backend grant exactly.
      direct_award: 'Direct Award',
      revert_direct_award: 'Revert Direct Award',
      // Spec-tab actions (mirror boqManagement so useSpecPermissions can reuse the keys).
      save_markup: 'Save Markup',
      view_history: 'View History',
      create_versions: 'Create Versions',
      upload_spec: 'Upload Spec',
    },
    rowItems: {
      // Union of the FFNE / OSNE / Finish management grids (see the three
      // *ManagementGrid.js binding= attributes).
      boq_packages: {
        availableColumns: {
          discipline_area: 'Discipline-Area',
          product_destination: 'Product Destination',
          spec_id: 'Spec ID',
          product_id: 'Product ID',
          category_sub_category: 'Category/Sub-Category',
          product_category: 'Product Category',
          product_sub_category: 'Product Sub-Category',
          item_name: 'Item Name',
          specification: 'Specification',
          vendor_spec: 'Vendor Spec',
          uom: 'UoM',
          total_qty: 'Total Qty',
          finish_spec_id: 'Finish Spec ID',
          finish_name: 'Finish Name',
          finish_category: 'Finish Category',
          finish_sub_category: 'Finish Sub-Category',
          finish_uom: 'Finish UoM',
          finish_qty: 'Finish Qty',
          action: 'Action',
        },
      },
      // FF&E Spec tab (shared SpecificationsGrid) — mirrors boqManagement.specifications columns.
      spec: {
        availableColumns: {
          action: 'Action',
          brand_mfr: 'Brand/Mfr',
          spec_id: 'Spec ID',
          name: 'Name',
          product_sub_category: 'Product Sub-Category',
          specification: 'Specification',
          uom_id: 'UoM',
          distributor: 'Distributor',
          image: 'Image',
        },
      },
    },
  },
  rfq: {
    feature: 'RFQ',
    screen: {
      create_rfq: 'Create RFQ',
      issue_rfq: 'Issue RFQ',
      vendor_costing: 'Vendor Costing',
    },
    action: {
      view: 'View',
      create: 'Create',
      edit: 'Edit',
      save: 'Save',
      delete: 'Delete',
      upload: 'Upload',
      comment: 'Comment',
      approve: 'Approve',
      issue: 'Issue',
      recall: 'Recall',
      close: 'Close',
      open_sealed_bid: 'Open Sealed Bid',
      download: 'Download',
    },
    rowItems: {
      create_rfq: {
        availableColumns: {
          // Packages tab grid
          package_name: 'Package Name',
          package_status: 'Package Status',
          package_action: 'Package Action',
          // RFQ Documents tab grid
          doc_type: 'Document Type',
          doc_date_received: 'Date Received',
          doc_uploaded_by: 'Uploaded By',
          doc_name: 'Attached Document Name',
          doc_comment: 'Comment',
          // Evaluation Criteria tab grid
          criteria: 'Criteria',
          criteria_weight: 'Weight',
          criteria_techno_commercial: 'Techno / Commercial',
          criteria_bid_question: 'Bid Question',
          criteria_methodology: 'Methodology',
          criteria_action: 'Actions',
        },
      },
      issue_rfq: {
        availableColumns: {
          // Package list grid columns
          package_name: 'Package Name',
          package_status: 'Package Status',
          package_action: 'Package Action',
          // Vendor status grid columns
          vendor: 'Vendor',
          issued_date: 'Issued Date',
          opened_date: 'Opened Date',
          quoted_date: 'Quoted Date',
          vendor_status: 'Vendor Status',
          vendor_action: 'Vendor Action',
        },
      },
      vendor_costing: {
        availableColumns: {
          spec_id: 'Spec ID',
          package_name: 'Package Name',
          product_category: 'Product Category',
          product_sub_category: 'Product Sub-Category',
          item_name: 'Item Name',
          specification: 'Specification',
          total_qty: 'Total Qty',
          uom: 'UoM',
          hs_code: 'HS Code',
          vendor_spec: 'Vendor Spec',
          unit_price: 'Unit Price',
          total_price: 'Total Price',
          action: 'Action',
          cbm_per_item: 'CBM Per Item',
          total_cbm: 'Total CBM',
          weight_per_item: 'Weight Per Item',
          weight_uom: 'Weight UoM',
          total_weight: 'Total Weight',
          item_spec_id: 'Item Spec ID',
          finish_spec_id: 'Finish Spec ID',
          finish_name: 'Finish Name',
          finish_uom: 'Finish UoM',
          finish_category_name: 'Finish Category - Type',
          finish_sub_category_name: 'Finish Sub-Category',
          vendor_quoted_quantity: 'Unit Quantity',
          multiplier: 'Multiplier',
          total_quantity: 'Total Quantity',
        },
      },
    },
  },
  cba: {
    feature: 'CBA',
    screen: {
      cba_summary: 'CBA Summary',
      cba_pricing: 'CBA Pricing',
      cba_quantification: 'CBA Quantification',
      cba_scoring: 'CBA Scoring',
    },
    action: {
      view: 'View',
      save: 'Save',
      edit: 'Edit',
      comment: 'Comment',
      award: 'Award',
      recall: 'Recall',
      issue: 'Issue',
      score: 'Score',
      download: 'Download',
    },
    rowItems: {
      // Transposed grid — these keys are hideable metric ROWS, gated by the
      // 4th-arg view field (e.g. hide the MARKUP VALUE / PROFIT MARGIN rows).
      cba_summary: {
        availableColumns: {
          markup: 'Markup Value',
          profit_margin: 'Profit Margin',
        },
      },
      // markup = the per-vendor Markup % + Markup Total columns (hide-column feature).
      cba_pricing: {
        availableColumns: {
          markup: 'Markup',
        },
      },
      cba_quantification: { availableColumns: {} },
      cba_scoring: { availableColumns: {} },
    },
  },
  template_administration: {
    feature: 'Template Administration',
    screen: {
      pqq: 'PQQ',
      boq: 'BOQ',
      rfq: 'RFQ',
    },
    action: {
      edit: 'Edit',
      view: 'View',
    },
    rowItems: {
      pqq: {
        availableColumns: {},
      },
      boq: {
        availableColumns: {},
      },
      rfq: {
        availableColumns: {},
      },
    },
  },
  user_administration: {
    feature: 'User Administration',
    screen: {
      roles_and_permissions: 'Roles and Permissions',
      user_listing: 'User Listing',
    },
    action: {
      edit: 'Edit',
      save_as: 'Save As',
      view: 'View',
      create: 'Create',
      delete: 'Delete',
    },
    rowItems: {
      roles_and_permissions: {
        availableColumns: {},
      },
      user_listing: {
        availableColumns: {
          action: 'Action',
          email: 'Email',
          name: 'Name',
          role: 'Role',
          user_id: 'User ID',
          status: 'Status',
          entity: 'Entity',
        },
      },
    },
  },
  vendor_administration: {
    feature: 'Vendor Administration',
    screen: {
      allowances: 'Allowances',
      details: 'Details',
      enquiries: 'Enquiries',
      file_uploaded: 'File Uploaded',
      listing: 'Listing',
      product_catalog: 'Product Catalog',
      vendor_pqq: 'Vendor PQQ',
    },
    action: {
      create: 'Create',
      edit: 'Edit',
      view: 'View',
      approval: 'Approval',
      download: 'Download',
      send_email: 'Send Email',
      delete: 'Delete',
      save_selection: 'Save Selection',
    },
    rowItems: {
      allowances: {
        availableColumns: {},
      },
      details: {
        availableColumns: {},
      },
      enquiries: {
        availableColumns: {
          action: 'Action',
          business_type: 'Business Type',
          company_name: 'Company Name',
          country: 'Country',
          date_time_received: 'Date/Time Received',
          email_id: 'Email ID',
          project_request: 'Project Request',
        },
      },
      file_uploaded: {
        availableColumns: {
          action: 'Action',
          document_type: 'Document Type',
          document_type_source: 'Document Type Source',
          file_size: 'File Size',
          uploaded_by: 'Uploaded By',
          uploaded_on: 'Uploaded On',
        },
      },
      listing: {
        availableColumns: {
          action: 'Action',
          allowance: 'Allowance',
          division: 'Division',
          location: 'Location',
          name: 'Name',
          score: 'Score',
          status: 'Status',
          vendor_type: 'Vendor Type',
          catalog: 'Catalog',
        },
      },
      product_catalog: {
        availableColumns: {
          brand: 'Brand',
          country_of_manufacturing: 'Country of Manufacturing',
          'distributor_product_#': 'Distributor Product #',
          hs_code: 'HS Code',
          item_name: 'Item Name',
          'manufacturer_product_#': 'Manufacturer Product #',
          patter_model: 'Pattern/Model',
          ships_from: 'Ships From',
          specification: 'Specification',
          unit_price: 'Unit Price',
          uom: 'UOM',
          action: 'Action',
        },
      },
      vendor_pqq: {
        availableColumns: {},
      },
    },
  },
  vendor_administration_client: {
    feature: 'Vendor Administration - Client',
    screen: {
      vendor_request: 'Vendor Request',
    },
    action: {
      approve: 'Approve',
      create: 'Create',
      view: 'View',
    },
    rowItems: {
      vendor_request: {
        availableColumns: {},
      },
    },
  },
  osne_master_data: {
    feature: 'OS&E Master Data',
    screen: {
      product_catalog: 'Product Catalog',
      product_destination: 'Product Destination',
      boq_template: 'BoQ Template',
      multiplier_rules: 'Multiplier Rules',
    },
    action: {
      create: 'Create',
      delete: 'Delete',
      edit: 'Edit',
      view: 'View',
      approve: 'Approve',
      download: 'Download',
    },
    rowItems: {
      product_catalog: {
        availableColumns: {
          itemName: 'Item Name',
          productId: 'Product ID',
          specification: 'Specification',
          brandOperator: 'Brand/Operator',
          tag: 'User Identifier/Tag',
          uom: 'UoM',
          price: 'Price',
          approved: 'Approved',
          action: 'Action',
        },
      },
      product_destination: {
        availableColumns: {
          '5STAR': '5 Star',
          '4STAR': '4 Star',
          '3STAR': '3 Star',
          discipline: 'Discipline',
          area: 'Area/Sub-Area',
          destination: 'Destination',
          category: 'Category',
          subCategory: 'Sub Category',
          itemName: 'Item Name',
          productId: 'Product ID',
          tag: 'User Identifier/Tag',
          specification: 'Specification',
          uom: 'UoM',
          price: 'Price',
          approved: 'Approved',
          action: 'Action',
        },
      },
      boq_template: {
        availableColumns: {
          productDestination: 'Product Destination',
          productCategory: 'Product Category',
          productSubCategory: 'Product Sub Category',
          itemName: 'Item Name',
          specification: 'Specification',
          productId: 'Product ID',
          tag: 'User Identifier/Tag',
          uom: 'UoM',
          vendorProductId: 'Vendor Product ID',
          vendorSpecification: 'Vendor Specification',
          estUnitPrice: 'Est. Unit Price(USD)',
          reference1: 'Reference 1',
          reference2: 'Reference 2',
          reference3: 'Reference 3',
          reference4: 'Reference 4',
          reference5: 'Reference 5',
          unitQty: 'Unit Qty',
          par: 'Par',
          hsCode: 'HS Code',
          approved: 'Approved',
          action: 'Action',
        },
      },
      multiplier_rules: {
        availableColumns: {
          discipline: 'Discipline',
          area: 'Area',
          currentMultiplierRule: 'Multiplier Rule',
          previousMultiplierRule: 'Previous Rule',
        },
      },
    },
  },
  capex_management: {
    feature: 'Capex',
    screen: {
      property_information_and_logistics: 'Property Information - Logistics',
      create_capex_request: 'Create Request',
      pending_capex_request: 'Pending Requests',
      approved_capex_request: 'Approved Requests',
      specifications: 'View/Edit Request',
    },
    action: {
      edit: 'Edit',
      view: 'View',
      approve: 'Approve',
    },
    rowItems: {
      property_information_and_logistics: {
        availableColumns: {},
      },
      create_capex_request: {
        availableColumns: {},
      },
      pending_capex_request: {
        availableColumns: {
          itemNumber: '#',
          serialNumber: 'Serial Number',
          itemName: 'Item Name',
          budgetPrice: 'Budget Price',
          purchasePrice: 'Purchase Price',
          requestDate: 'Request Date',
          requestor: 'Requestor',
          status: 'Status',
          action: 'Action',
        },
      },
      approved_capex_request: {
        availableColumns: {
          itemNumber: '#',
          serialNumber: 'Serial Number',
          itemName: 'Item Name',
          budgetPrice: 'Budget Price',
          purchasePrice: 'Purchase Price',
          requestDate: 'Request Date',
          requestor: 'Requestor',
          status: 'Status',
          action: 'Action',
        },
      },
      specifications: {
        availableColumns: {},
      },
    },
  },
  osne_boq_budget: {
    feature: 'OS&E BOQ & Budget',
    screen: {
      boq_listing: 'BoQ Listing',
      boq_budget: 'BoQ Budget',
      boq_summary: 'BoQ Summary',
    },
    action: {
      create: 'Create',
      delete: 'Delete',
      edit: 'Edit',
      view: 'View',
      download: 'Download',
      comment: 'Comment',
      approve: 'Approve',
      create_version: 'Create Version',
      submit: 'Submit',
    },
    rowItems: {
      boq_listing: {
        availableColumns: {
          refNo: 'BoQ Ref No',
          lastUpdatedByName: 'Last Updated By',
          updatedAt: 'Last Updated At',
          status: 'Status',
          action: 'Action',
        },
      },
      boq_budget: {
        availableColumns: {
          productDestinationName: 'Product Destination',
          productCategory: 'Product Category',
          productSubCategory: 'Product Sub-Category',
          itemName: 'Item Name',
          productId: 'Product ID',
          specification: 'Specification',
          uom: 'UoM',
          vendorProductId: 'Vendor Product ID',
          vendorSpecification: 'Vendor Specification',
          price: 'Est. Unit Price',
          budgetUnitPrice: 'Budget Unit Price',
          reference1: 'Reference 1',
          reference2: 'Reference 2',
          reference3: 'Reference 3',
          reference4: 'Reference 4',
          reference5: 'Reference 5',
          unitQuantity: 'Unit Qty',
          multiplier: 'Multiplier',
          totalQty: 'Total Qty',
          par: 'Par',
          finalQty: 'Final Qty',
          finalCostPrice: 'Final Cost Price',
          finalBudgetPrice: 'Final Budget Price',
          status: 'Status',
          hsCode: 'HS Code',
          view: 'View',
          action: 'Action',
        },
      },
      boq_summary: {
        availableColumns: {
          summaryName: 'Summary Name',
          costPrice: 'Cost Price',
          budgetPrice: 'Budget Price',
          approved: 'Approved',
          budgetMetrics: 'Budget Metrics',
          currencyValue: 'Budget Metrics Value',
          sendToTendering: 'Send to Tendering',
        },
      },
    },
  },
  // Post-award package screens (PO Package + PO FF&E Spec) and the submittal
  // tracking tabs. Split out of `post_contract` so they can be granted
  // independently of the Purchasing (PO) and Invoice screens.
  awarded_package: {
    feature: 'Awarded Package',
    screen: {
      awarded_packages: 'PO Package',
      awarded_packages_spec: 'PO FF&E Spec',
      specification_material_logs: 'Material Log',
      specification_drawing_logs: 'Drawing Log',
      specification_production_dashboard: 'Production Dashboard',
      specification_finish_report: 'Finish Report',
    },
    action: {
      save: 'Save',
      view: 'View',
      create_version: 'Create Version',
      delete: 'Delete',
      approve: 'Approve',
      download: 'Download',
      prepare_transmital: 'Prepare Transmital',
      generate_report: 'Generate Report',
      // Package / spec-tab actions (mirror boq_management + tender_packages so
      // the shared grids can reuse the keys).
      create: 'Create',
      edit: 'Edit',
      move_to_package: 'Move to Package',
      comment: 'Comment',
      save_markup: 'Save Markup',
      view_history: 'View History',
      create_versions: 'Create Versions',
      upload_spec: 'Upload Spec',
    },
    rowItems: {
      // PO Package (Awarded Packages) — union of the FFNE / Finish / OSNE grid columns.
      awarded_packages: {
        availableColumns: {
          discipline_area: 'Discipline - Area',
          spec_id: 'Spec ID',
          item_spec_id: 'Item Spec ID',
          category_sub_category: 'Category - Sub-Category',
          product_destination: 'Product Destination',
          product_category: 'Product Category',
          product_sub_category: 'Product Sub-Category',
          item_name: 'Item Name',
          specification: 'Specification',
          product_id: 'Product ID',
          finish_spec_id: 'Finish Spec ID',
          finish_name: 'Finish Name',
          finish_category: 'Finish Category',
          finish_sub_category: 'Finish Sub-Category',
          finish_uom: 'Finish UoM',
          finish_qty: 'Finish Qty',
          vendor_spec: 'Vendor Spec',
          uom: 'UoM',
          total_qty: 'Total Qty',
          unit_price: 'Unit Price',
          total_price: 'Total Price',
          hs_code: 'HS Code',
          action: 'Action',
        },
      },
      // PO FF&E Spec tab (shared SpecificationsGrid) — mirrors tender_packages.spec columns.
      awarded_packages_spec: {
        availableColumns: {
          action: 'Action',
          brand_mfr: 'Brand/Mfr',
          spec_id: 'Spec ID',
          name: 'Name',
          product_sub_category: 'Product Sub-Category',
          specification: 'Specification',
          uom_id: 'UoM',
          distributor: 'Distributor',
          image: 'Image',
        },
      },
      specification_material_logs: {
        availableColumns: {
          specId: 'Item Spec Id',
          productName: 'Product Description',
          finishSpecId: 'Finish Spec ID',
          finishSubCategory: 'Finish sub-category',
          finishName: 'Finish Description',
          controlSampleRecd: 'Control Sample Recd',
          controlSampleImage: 'Control Sample Image',
          finishImage: 'Finish Image',
          finishVendorId: 'Specified Finish Vendor',
          productVendorId: 'Product Manufacturer',
          approvedVendorId: 'Approved Manufacturer ',
          transmittal: 'Transmittal#',
          submissionType: 'Submission Type',
          submissionDate: 'Submission Date',
          submittalRemarks: 'Submittal Remarks',
          approvalStatus: 'Approval Status',
          approvalDate: 'Approval Date',
          submittalHistory: 'Actions',
        },
      },
      specification_drawing_logs: {
        availableColumns: {
          specId: 'Item Spec Id',
          productName: 'Product Description',
          productSubCategory: 'Product sub-category',
          vendorId: 'Vendor',
          po: 'PO#',
          prototype: 'Prototype',
          transmittal: 'Transmittal#',
          submissionType: 'Submission Type',
          submissionDate: 'Submission Date',
          submittalRemarks: 'Submittal Remarks',
          approvalStatus: 'Approval Status',
          approvalDate: 'Approval Date',
          submittalHistory: 'Actions',
        },
      },
      specification_production_dashboard: {
        availableColumns: {
          po: 'PO#',
          specId: 'Item Spec Id',
          productName: 'Product Description',
          materialLogStatus: 'Material Log Status',
          drawingLogStatus: 'Drawing Log Status',
        },
      },
      // Finish Report — read-only view over the material log GET; v2 projects get
      // this in place of the Material Log / Drawing Log / Production Dashboard tabs.
      specification_finish_report: {
        availableColumns: {
          specId: 'Item Spec Id',
          productName: 'Product Description',
          itemCategory: 'Product sub-category',
          finishImage: 'Finish Image',
          finishSpecId: 'Finish Spec ID',
          finishSubCategory: 'Finish sub-category',
          finishName: 'Finish Description',
        },
      },
    },
  },
  // Purchase Order screens. Split out of `post_contract` so PO access can be
  // granted independently of the Invoice / Expediting screens.
  purchasing: {
    feature: 'Purchasing',
    screen: {
      purchase_order_list: 'PO List',
      purchase_order_detail: 'PO Detail',
      purchase_order_payment_terms: 'PO Payment Terms',
      purchase_order_items: 'PO Items',
      purchase_order_supporting_docs: 'PO Supporting Docs',
    },
    action: {
      save: 'Save',
      view: 'View',
      create_version: 'Create Version',
      delete: 'Delete',
      approve: 'Approve',
      download: 'Download',
      prepare_transmital: 'Prepare Transmital',
      generate_report: 'Generate Report',
    },
    rowItems: {
      purchase_order_list: {
        availableColumns: {
          poNo: 'PO#',
          poName: 'PO Name',
          supplier: 'Supplier',
          incoTerms: 'Inco Terms',
          poCurrency: 'PO Currency',
          poValue: 'PO Value',
          poTaxValue: 'PO Tax Value',
          totalPoValue: 'Total PO Value',
          action: 'Action',
        },
      },
      purchase_order_detail: {
        availableColumns: {},
      },
      purchase_order_payment_terms: {
        availableColumns: {
          milestone: 'Milestone',
          description: 'Description',
          pmtPercentage: 'Payment Percentage',
          poValuePoCurrency: 'PO Value (PO Currency)',
          poValueProjectCurrency: 'PO Value (Project Currency)',
          action: 'Action',
        },
      },
      purchase_order_items: {
        availableColumns: {
          specificationId: 'Spec ID',
          finishId: 'Finish ID',
          productId: 'Product ID',
          itemDescription: 'Item Description',
          vendorItemSpec: 'Vendor Item Spec',
          area: 'Area',
          qty: 'Qty',
          uom: 'UoM',
          unitPricePoCurrency: 'Unit Price (PO Currency)',
          totalPricePoCurrency: 'Total Price (PO Currency)',
          totalPriceBaseCurrency: 'Total Price (Base Currency)',
          actions: 'Actions',
        },
      },
      purchase_order_supporting_docs: {
        availableColumns: {
          documentType: 'Document Type',
          dateReceived: 'Date Received',
          uploadedBy: 'Uploaded By',
          attachedDocumentName: 'Attached Document Name',
          fileSize: 'File Size',
          comments: 'Comments',
          action: 'Action',
        },
      },
    },
  },
  // Invoice + Expediting screens. The post-award package and PO screens moved
  // out to `awarded_package` / `purchasing`.
  post_contract: {
    feature: 'Post Contract',
    screen: {
      invoice_list: 'Invoice List',
      invoice_detail: 'Invoice Detail',
      invoice_items: 'Invoice Items',
      invoice_supporting_docs: 'Invoice Supporting Docs',
      invoice_project_po_dashboard: 'Project-PO Dashboard',
      invoice_vendor_po_dashboard: 'Vendor-PO Dashboard',
      expediting: 'Expediting',
    },
    action: {
      save: 'Save',
      view: 'View',
      create_version: 'Create Version',
      delete: 'Delete',
      approve: 'Approve',
      download: 'Download',
      prepare_transmital: 'Prepare Transmital',
      generate_report: 'Generate Report',
    },
    rowItems: {
      invoice_list: {
        availableColumns: {
          poNumber: 'PO #',
          paymentType: 'Payment Type',
          vendorName: 'Vendor Name',
          invoiceNo: 'Invoice No',
          invoiceDate: 'Invoice Date',
          invoiceCurrency: 'Invoice Currency',
          invoiceValue: 'Invoice Value (Currency)',
          currencyVat: 'Currency VAT (Currency)',
          totalValueCurrency: 'Total Value (Currency)',
          invoiceValueBase: 'Invoice Value (Base Currency)',
          vatValueBase: 'VAT Value (Base Currency)',
          totalInvValueBase: 'Total Inv. Value (Base Currency)',
          submittedDate: 'Submitted Date',
          transmittalNo: 'Transmittal No',
          paidAmount: 'Paid Amount (Base Currency)',
          paidDate: 'Paid Date',
          paymentStatus: 'Payment Status',
          overdueDays: 'Overdue Days',
          action: 'Action',
        },
      },
      invoice_detail: {
        availableColumns: {},
      },
      invoice_items: {
        availableColumns: {
          srNo: 'Serial No.',
          specId: 'Spec ID',
          finishSpecId: 'Finish Spec ID',
          productId: 'Product ID',
          description: 'Description',
          area: 'Area',
          poQty: 'Purchase Order Quantity',
          uom: 'UOM',
          unitPrice: 'Unit Price (PO Currency)',
          totalPricePoCurr: 'Total Price (PO Currency)',
          totalPriceBaseCurr: 'Total Price (Base Currency)',
          qtyDeliveredBefore: 'Qty Delivered Before this Invoice',
          qtyDeliveredVo: 'Qty Delivered In this Invoice',
          pendingDelivery: 'Pending Delivery',
          vendorInvoiceValue: 'Vendor Invoice Value',
          calculatedInvoiceValue: 'Calculated Invoice Value',
        },
      },
      invoice_supporting_docs: {
        availableColumns: {
          documentType: 'Document Type',
          dateReceived: 'Date Received',
          uploadedBy: 'Uploaded By',
          attachedDocumentName: 'Attached Document Name',
          fileSize: 'File Size',
          comments: 'Comments',
          action: 'Action',
        },
      },
      invoice_project_po_dashboard: {
        availableColumns: {
          serialNo: 'SL NO',
          po: 'PO #',
          paymentType: 'Payment Type',
          invoiceNo: 'INV #',
          invoiceDate: 'INV Date',
          submittedDate: 'Submitted Date',
          transmittalNo: 'Transmittal #',
          paidAmount: 'Paid Amount',
          paidDate: 'Paid Date',
          paymentStatus: 'Status',
          overdueDays: 'Overdue Days',
        },
      },
      invoice_vendor_po_dashboard: {
        availableColumns: {
          slNo: 'SL NO',
          po: 'PO #',
          poName: 'PO Name',
          supplier: 'Supplier',
          incoTerm: 'Inco Term',
          poCurrency: 'PO Currency',
          poValueCurrency: 'PO Value (PO Curr)',
          paymentTerms: 'Payment Terms',
          outstandingPayment: 'Outstanding Payment',
        },
      },
      expediting: {
        availableColumns: {
          srNo: 'Sr#',
          specId: 'Spec ID',
          finishSpecId: 'Finish Spec ID',
          productId: 'Product ID',
          itemDescription: 'Item Description',
          area: 'Area',
          qty: 'Qty',
          uom: 'UoM',
          unitRate: 'Unit Rate',
          totalPrice: 'Total Price',
          advancePaid: 'Advance Paid',
          materialApproved: 'Material Approved',
          drawingApproved: 'Drawing Approved',
          etaForecast: 'ETA Forecast',
          totalRecvdQty: 'Total Recvd Qty',
          recvdRate: 'Recvd Rate',
          recvdAmount: 'Recvd Amount',
          pendingQty: 'Pending Qty',
          pendingAmount: 'Pending Amount',
          actions: 'Actions',
        },
      },
    },
  },
};

export const PERMISSION_MODULES = {
  boqManagement: 'boq_management',
  designerAdministration: 'designer_administration',
  enquiryManagement: 'enquiry_management',
  masterDataAdministration: 'master_data_administration',
  operatorAdministration: 'operator_administration',
  clientAdministration: 'client_administration',
  divisionManagement: 'division_management',
  projectManagement: 'project_management',
  rfp: 'rfp',
  templateAdministration: 'template_administration',
  userAdministration: 'user_administration',
  vendorAdministration: 'vendor_administration',
  vendorAdministrationClient: 'vendor_administration_client',
  analysis: 'analysis',
  projectInformation: 'project_information',
  budgetManagement: 'budget_management',
  osneMasterData: 'osne_master_data',
  osneBoQBudget: 'osne_boq_budget',
  capexManagement: 'capex_management',
  awardedPackage: 'awarded_package',
  purchasing: 'purchasing',
  postContract: 'post_contract',
  tenderPackages: 'tender_packages',
  rfq: 'rfq',
  cba: 'cba',
};

export const PERMISSION_SCREEN = {
  discipline: 'discipline',
  area: 'area',
  productCategory: 'product_category',
  productSubCategory: 'product_sub_category',
  currency: 'currency',
  tax_type: 'tax_type',
  enquiry: 'enquiry',
  enquiry_form: 'enquiry_form',
  client_listing: 'client_listing',
  operator: 'operator',
  division: 'division',
  designer: 'designer',
  roles_and_permissions: 'roles_and_permissions',
  user_listing: 'user_listing',
  category_markup: 'category_markup',
  details: 'details',
  file_ploads: 'file_ploads',
  project_list: 'project_list',
  specifications: 'specifications',
  taxes: 'taxes',
  allowances: 'allowances',
  enquiries: 'enquiries',
  listing: 'listing',
  vendor_pqq: 'vendor_pqq',
  file_uploaded: 'file_uploaded',
  pqq: 'pqq',
  banquets: 'banquets',
  bill_to_ship_to_adress: 'bill_to_ship_to_adress',
  document_register: 'document_register',
  drawing_and_layouts: 'drawing_and_layouts',
  fnb_restaurents: 'fnb_restaurents',
  ffne_file_uploads: 'ffne_file_uploads',
  input_matrix: 'input_matrix',
  osne_file_uploads: 'osne_file_uploads',
  others: 'others',
  project_logistics: 'project_logistics',
  recreational_areas: 'recreational_areas',
  specification_and_finishes: 'specification_and_finishes',
  stakeholder_information: 'stakeholder_information',
  boq_listing: 'boq_listing',
  ffne_boq_details: 'ffne_boq_details',
  detail_costing: 'detail_costing',
  finish_costing: 'finish_costing',
  finish_quantity: 'finish_quantity',
  commercial_terms: 'commercial_terms',
  create_rfps: 'create_rfps',
  issue_rfps: 'issue_rfps',
  summary_vc: 'summary_vc',
  detail_vc: 'detail_vc',
  detailed_budget: 'detailed_budget',
  open_items: 'open_items',
  summary_budget: 'summary_budget',
  product_catalog: 'product_catalog',
  product_destination: 'product_destination',
  boq_template: 'boq_template',
  property_information_and_logistics: 'property_information_and_logistics',
  create_capex_request: 'create_capex_request',
  pending_capex_request: 'pending_capex_request',
  approved_capex_request: 'approved_capex_request',
  boq_budget: 'boq_budget',
  boq_summary: 'boq_summary',
  multiplier_rules: 'multiplier_rules',
  finish_category: 'finish_category',
  finish_category_type: 'finish_category_type',
  specification_material_logs: 'specification_material_logs',
  specification_drawing_logs: 'specification_drawing_logs',
  specification_production_dashboard: 'specification_production_dashboard',
  specification_finish_report: 'specification_finish_report',
  awarded_packages: 'awarded_packages',
  awarded_packages_spec: 'awarded_packages_spec',
  purchase_order_list: 'purchase_order_list',
  purchase_order_detail: 'purchase_order_detail',
  purchase_order_payment_terms: 'purchase_order_payment_terms',
  purchase_order_items: 'purchase_order_items',
  purchase_order_supporting_docs: 'purchase_order_supporting_docs',
  invoice_list: 'invoice_list',
  invoice_detail: 'invoice_detail',
  invoice_items: 'invoice_items',
  invoice_supporting_docs: 'invoice_supporting_docs',
  invoice_project_po_dashboard: 'invoice_project_po_dashboard',
  invoice_vendor_po_dashboard: 'invoice_vendor_po_dashboard',
  expediting: 'expediting',
  // Tendering module screens
  boq_packages: 'boq_packages',
  create_rfq: 'create_rfq',
  issue_rfq: 'issue_rfq',
  vendor_costing: 'vendor_costing',
  cba_summary: 'cba_summary',
  cba_pricing: 'cba_pricing',
  cba_quantification: 'cba_quantification',
  cba_scoring: 'cba_scoring',
  spec: 'spec',
};
